export const SET_MAP = 'SET_MAP';
export const ADD_INTERACTION = 'ADD_INTERACTION';
export const CLEAR_INTERACTION_TYPE = 'CLEAR_INTERACTION_TYPE';
